// Donations block schema - Accept donations from supporters
export const donationsSchema = {
  type: 'donations',
  label: 'Donations',
  description: 'Accept donations from supporters',
  icon: 'HeartHandshake',
  defaultContent: {
    heading: 'Support My Work',
    description: '',
    buttonText: 'Donate',
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Heading', type: 'text', placeholder: 'Support My Work' },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'buttonText', label: 'Button Text', type: 'text', placeholder: 'Donate' },
  ],
};
